<template>
  <div>
    <div class="mt-3">
      <vs-row id="center">
        <h5 class="headerText">Work Order​</h5>
        <vs-spacer /> <btnBulk :selectedWO="selectedWO" />
        <btnMultiple :dataList="tempdata" :headerName="'Work Order'"
      /></vs-row>
    </div>

    <!-- <pre>{{ searchHeader }}</pre> -->
    <!-- <vs-select class="selectExample" label="Figuras" v-model="searchHeader">
      <vs-select-item
        :key="index"
        :value="item"
        :text="item"
        v-for="(item, index) in header"
      />
    </vs-select> -->

    <!-- <vs-select
      placeholder="Search and select"
      label="Autocomplete"
      label-placeholder="Autocomplete"
      multiple
      autocomplete
      v-model="searchHeader"
    >
      <vs-select-item
        :key="index"
        :value="item"
        :text="item"
        v-for="(item, index) in header"
      />
    </vs-select> -->

    <!-- <div v-for="header in searchHeader" :key="header">
      <vs-select
        v-if="header == 'WO Name'"
        label="WO Name"
        v-model="searchItem"
      >
        <vs-select-item
          :key="index"
          :value="item.name"
          :text="item.name"
          v-for="(item, index) in tempdata"
        />
      </vs-select>
      <vs-icon
        v-if="header == 'WO Name'"
        @click="remove(header)"
        icon="mood"
      ></vs-icon>
      <vs-select
        v-if="header == 'Assigned To'"
        label="Assigned To"
        v-model="searchItem2"
      >
        <vs-select-item
          :key="index"
          :value="item.username"
          :text="item.username"
          v-for="(item, index) in tempdata"
        />
      </vs-select>
      <vs-icon
        v-if="header == 'Assigned To'"
        @click="remove(header)"
        icon="mood"
      ></vs-icon>
    </div> -->

    <!-- <vs-input class="inputx" placeholder="Placeholder" v-model="searchh" /> -->
    <!-- <pre>{{ selectFilterAssignedTo }}</pre> -->
    <div class="mt-3 ml-2 filterContentHeader">
      <span class="mr-2">Filter by :</span>
      <vs-select
        placeholder="Select filter"
        multiple
        class="fontSizeData"
        v-model="searchHeader"
      >
        <vs-select-item
          :key="index"
          :value="item"
          :text="item"
          v-for="(item, index) in headerFilter"
        />
      </vs-select>
    </div>

    <vs-row>
      <div
        class="mt-2 fontSizeData"
        v-for="header in searchHeader"
        :key="header"
      >
        <div v-if="header == 'WO Name'">
          <div class="textfill textSuccess"><span>WO Name</span></div>
          <div class="contentitem">
            <vs-input
              class="inputx"
              placeholder="Search Name"
              v-model="selectFilterName"
            />
            <vs-icon
              class="clearIcon"
              size="0.9rem"
              color="light"
              @click="remove(header)"
              icon="close"
            ></vs-icon>
          </div>
        </div>
        <div v-if="header == 'Priority'">
          <div class="textfill textSuccess"><span>Priority</span></div>
          <div class="contentitem">
            <vs-select
              placeholder="Select Priority"
              v-model="selectFilterPriority"
            >
              <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.text"
                v-for="(item, index) in filterPriority"
              />
            </vs-select>
            <vs-icon
              class="clearIcon"
              size="0.9rem"
              color="light"
              @click="remove(header)"
              icon="clear"
            ></vs-icon>
          </div>
        </div>
        <div v-if="header == 'Assigned To'">
          <div class="textfill textSuccess"><span>Assigned To</span></div>
          <div class="contentitem">
            <vs-select
              placeholder="Select Assigned To"
              v-model="selectFilterAssignedTo"
            >
              <vs-select-item
                :key="index"
                :value="item"
                :text="item"
                v-for="(item, index) in filterAssignedTo"
              />
            </vs-select>
            <vs-icon
              class="clearIcon"
              size="0.9rem"
              color="light"
              @click="remove(header)"
              icon="clear"
            ></vs-icon>
          </div>
        </div>
        <div v-if="header == 'Creator'">
          <div class="textfill textSuccess"><span>Creator</span></div>
          <div class="contentitem">
            <vs-select
              placeholder="Select Creator"
              v-model="selectFilterCreator"
            >
              <vs-select-item
                :key="index"
                :value="item"
                :text="item"
                v-for="(item, index) in filterCreator"
              />
            </vs-select>
            <vs-icon
              class="clearIcon"
              size="0.9rem"
              color="light"
              @click="remove(header)"
              icon="clear"
            ></vs-icon>
          </div>
        </div>

        <div v-if="header == 'Start Date'">
          <div class="textfill textSuccess"><span>Start Date</span></div>
          <div class="contentitem">
            <VueCtkDateTimePicker
              position="bottom"
              onlyDate
              noHeader
              noLabel
              format="YYYY-MM-DD"
              v-model="selectFilterStartDate"
            >
              <button
                class="vs-select--input fontSizeData"
                style="background: white; width: 200px"
                type="button"
                @click="width200"
              ></button
            ></VueCtkDateTimePicker>
            <vs-icon
              class="clearIcon"
              size="0.9rem"
              color="light"
              @click="remove(header)"
              icon="clear"
            ></vs-icon>
          </div>
        </div>
        <div v-if="header == 'End Date'">
          <div class="textfill textSuccess"><span>End Date</span></div>
          <div class="contentitem">
            <VueCtkDateTimePicker
              position="bottom"
              onlyDate
              noHeader
              noLabel
              format="YYYY-MM-DD"
              v-model="selectFilterEndDate"
            >
              <button
                class="vs-select--input fontSizeData"
                style="background: white; width: 200px"
                type="button"
                @click="width200"
              ></button
            ></VueCtkDateTimePicker>
            <vs-icon
              class="clearIcon"
              size="0.9rem"
              color="light"
              @click="remove(header)"
              icon="clear"
            ></vs-icon>
          </div>
        </div>
        <div v-if="header == 'Status'">
          <div class="textfill textSuccess"><span>Status</span></div>
          <div class="contentitem">
            <vs-select placeholder="Select Status" v-model="selectFilterActive">
              <vs-select-item
                :key="index"
                :value="item"
                :text="item"
                v-for="(item, index) in filterActive"
              />
            </vs-select>
            <vs-icon
              class="clearIcon"
              size="0.9rem"
              color="light"
              @click="remove(header)"
              icon="clear"
            ></vs-icon>
          </div>
        </div>
        <div v-if="header == 'Type'">
          <div class="textfill textSuccess"><span>Type</span></div>
          <div class="contentitem">
            <vs-select placeholder="Select Type" v-model="selectFilterType">
              <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.text"
                v-for="(item, index) in filterType"
              />
            </vs-select>
            <vs-icon
              class="clearIcon"
              size="0.9rem"
              color="light"
              @click="remove(header)"
              icon="clear"
            ></vs-icon>
          </div>
        </div>
        <div v-if="header == 'Response'">
          <div class="textfill textSuccess"><span>Response</span></div>
          <div class="contentitem">
            <vs-select
              placeholder="Select Response"
              v-model="selectFilterResponse"
            >
              <vs-select-item
                :key="index"
                :value="item"
                :text="item"
                v-for="(item, index) in filterResponse"
              />
            </vs-select>
            <vs-icon
              class="clearIcon"
              size="0.9rem"
              color="light"
              @click="remove(header)"
              icon="clear"
            ></vs-icon>
          </div>
        </div>
        <div v-if="header == 'Asset'">
          <div class="textfill textSuccess"><span>Asset</span></div>
          <div class="contentitem">
            <vs-select placeholder="Select Asset" v-model="selectFilterAsset">
              <vs-select-item
                :key="index"
                :value="item"
                :text="item"
                v-for="(item, index) in filterAsset"
              />
            </vs-select>
            <vs-icon
              class="clearIcon"
              size="0.9rem"
              color="light"
              @click="remove(header)"
              icon="clear"
            ></vs-icon>
          </div>
        </div>
      </div>
    </vs-row>
    <div>
      <!-- <pre>{{filteredList}}</pre> -->
      <!-- Data :  filteredList -->
      <vs-table search :data="filteredList" hoverFlat="false">
        <template slot="thead">
          <vs-th>
            <input type="checkbox" v-model="selectAllWO" @click="selectWO" />
          </vs-th>
          <vs-th></vs-th>
          <vs-th
            v-for="item in header"
            :key="item.name"
            sort-key="name"
            id="noWrap"
          >
            {{ item }}
            <span><vs-icon icon="unfold_more" size="13px"></vs-icon></span>
          </vs-th>
        </template>
        <template slot-scope="{ data }">
          <vs-tr
            id="fontSizeData"
            :class="{ opened: opened.includes(indextr) }"
            :data="tr"
            :key="indextr"
            v-for="(tr, indextr) in data"
          >
            <vs-td>
              <input
                type="checkbox"
                :value="data[indextr]"
                @click="select(), toggle(indextr)"
                v-model="selectedWO"
              />
            </vs-td>
            <!-- more button -->
            <vs-td style="width: 0; padding: 0">
              <vs-dropdown
                vs-trigger-click
                left
                class="cursor-pointer pr-2 pl-2 ml-1 mr-1"
              >
                <a class="text-dark" href="#">
                  <span>
                    <vs-icon
                      icon="more_vert"
                      id="fontIcon"
                      color="black"
                    ></vs-icon>
                  </span>
                </a>
                <vs-dropdown-menu class="topbar-dd fontSizeData">
                  <vs-dropdown-item
                    @click="
                      showModalCom((viewdata = data[indextr])), pushData()
                    "
                    ><span
                      ><vs-icon
                        icon="visibility"
                        id="fontIcon"
                        class="mr-2"
                      ></vs-icon></span
                    >View</vs-dropdown-item
                  >
                  <!-- <vs-dropdown-item
                    v-if="role == 'admin'"
                    @click="
                      showModalEdit((viewdata = data[indextr])), pushData()
                    "
                  >
                    <span
                      ><vs-icon
                        icon="create"
                        id="fontIcon"
                        class="mr-2"
                      ></vs-icon></span
                    >Edit
                  </vs-dropdown-item> -->
                  <vs-dropdown-item
                    @click="completeTask((buttonComplete = data[indextr]))"
                  >
                    <span
                      ><vs-icon
                        icon="done"
                        id="fontIcon"
                        class="mr-2"
                      ></vs-icon></span
                    >Complete
                  </vs-dropdown-item>
                  <vs-dropdown-item
                    v-if="role == 'admin'"
                    @click="showModalDelete((buttonDelete = data[indextr]))"
                  >
                    <span
                      ><vs-icon
                        icon="delete"
                        id="fontIcon"
                        class="mr-2"
                      ></vs-icon></span
                    >Delete
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </vs-td>
            <vs-td style="width: 15px" :data="data[indextr].priority">
              <span
                v-if="data[indextr].priority == '1 - Low priority'"
                class="
                  font-weight-bold
                  badge
                  badgePrioSuccess
                  textSuccess
                  badge-pill
                  px-2
                  py-1
                "
              >
                1 - Low
              </span>
              <span
                v-if="data[indextr].priority == '2 - Medium priority'"
                color="black"
                class="
                  font-weight-bold
                  badge
                  badgePrioWarning
                  textWarning
                  badge-pill
                  px-2
                  py-1
                "
              >
                2 - Medium</span
              >

              <span
                v-if="data[indextr].priority == '3 - High priority'"
                class="
                  font-weight-bold
                  badge
                  badgePrioDanger
                  textDanger
                  badge-pill
                  px-2
                  py-1
                "
              >
                3 - High
              </span>
            </vs-td>
            <vs-td :data="data[indextr].name">
              <a
                id="viewData"
                v-b-modal.modal-2
                @click="(viewdata = data[indextr]), pushData()"
              >
                {{ data[indextr].name }} #{{ data[indextr].id }} -</a
              ><a class="ml-2" id="viewAsset">{{ data[indextr].asset }}</a>
            </vs-td>
            <vs-td>
              <div
                @click="
                  show = true;
                  show1(data[indextr]);
                "
              >
                {{ data[indextr].asset }}
              </div>
            </vs-td>
            <vs-td>
              <div
                @click="
                  show = true;
                  show1(data[indextr]);
                "
              >
                {{ data[indextr].username }}
              </div>
            </vs-td>
            <vs-td>
              <div
                @click="
                  show = true;
                  show1(data[indextr]);
                "
              >
                Creator
              </div>
            </vs-td>
            <vs-td>
              <div
                @click="
                  show = true;
                  show1(data[indextr]);
                "
              >
                {{ data[indextr].plandate }}
              </div>
            </vs-td>
            <vs-td>
              <div
                @click="
                  show = true;
                  show1(data[indextr]);
                "
              >
                {{ data[indextr].duedate }}
              </div>
            </vs-td>
            <vs-td>
              {{ data[indextr].iscomplete }}
            </vs-td>
            <vs-td>
              {{ data[indextr].response }}
            </vs-td>
            <vs-td>
              {{ data[indextr].overdue }}
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>
    <div id="myDiv"></div>
    <!-- Madal Customize -->
    <b-modal
      id="modal-2"
      size="xl"
      class="w-100"
      ref="modal-2"
      no-close-on-backdrop="false"
      hide-header-close
      scrollable
      centered
      header-close-label
    >
      <template #modal-title>
        <h5 style="color: #32c040">View Work Order</h5>
      </template>
      <vs-tabs>
        <vs-tab label="Work Order">
          <!-- <vs-row id="center">
            <span>
              {{ viewdata.name }} #<a class="font-weight-bold">
                {{ viewdata.id }}</a
              >
            </span>
            <vs-spacer />
            <vs-dropdown vs-trigger-click left>
              <vs-button
                color="rgba(9, 30, 66, 0.04)"
                type="filled"
                icon="share"
                id="btnShare"
                >Share</vs-button
              >
            
              <vs-dropdown-menu style="width: max-content" class="fontSizeData">
                <vs-dropdown-item @click="printTemplate">
                  <vs-icon icon="print" class="mr-1" id="fontIcon"></vs-icon
                  >Print
                </vs-dropdown-item>
                <vs-dropdown-item>
                  <vs-icon icon="email" class="mr-1" id="fontIcon"></vs-icon
                  >Send a Reminder
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </vs-row> -->
          <WorkTemplate
            :viewwork="viewdata"
            :dataPrint="dataPrint"
            :updateData="updateData"
            :workerlist="workerlist"
          />
        </vs-tab>
        <vs-tab label="Parts" @click="getpart">
          <div>
            <vs-row>
              <vs-spacer />
              <!-- <span class="mt-2 pt-1 mr-3"
                >{{ total_part }} parts | ฿ {{ total_cost }}</span
              > -->
              <vs-button
                style="border-radius: 20px"
                icon="assignment_return"
                v-b-modal="'modal-returnpart'"
                user="'partsRequest'"
                user2="'WOreturn"
              >
                <!-- @click="ReturnParts(partsRequest)" -->
                Return Parts</vs-button
              >
            </vs-row>
            <br />
            <b-table
              striped
              hover
              outlined
              :items="partsRequest"
              :fields="partsRequestheader"
            >
              <template #cell(order_id)="item">
                <a> # Order-{{ item.value }} </a>
              </template>
            </b-table>
          </div>
        </vs-tab>
      </vs-tabs>

      <template #modal-footer>
        <vs-button
          v-if="role == 'user' && viewdata.response == 'Acknowledged'"
          @click="Downtime(viewdata)"
          class="brdbtn"
          color="success"
          type="filled"
          >Submit</vs-button
        >
        <vs-button class="brdbtn" color="dark" type="flat" @click="cancelReload"
          >Close</vs-button
        >
      </template>
    </b-modal>

    <b-modal
      id="modal-Downtime"
      ref="modalDowntime"
      hide-header-close
      size="xl"
    >
      <template #modal-title>
        <h5 style="color: #32c040">Submit Task​</h5>
      </template>
      <downtime :downtime="downtime" />
      <template #modal-footer>
        <vs-button
          class="brdbtn"
          @click="submitWO(viewdata)"
          color="success"
          type="filled"
          >Save</vs-button
        >
        <vs-button class="brdbtn" @click="hideDowntime" color="dark" type="flat"
          >Close</vs-button
        >
      </template>
    </b-modal>

    <b-modal
      id="modal-Edit"
      ref="modalEdit"
      scrollable
      no-close-on-backdrop="false"
      hide-header-close
      size="xl"
    >
      <template #modal-title>
        <h5 style="color: rgb(255, 145, 30)">Edit Work Order​</h5>
      </template>
      <EditWorkOrder
        :viewwork="viewdata"
        :updateData="updateData"
        :workerlist="workerlist"
        :filterPriority="filterPriority"
      />
      <template #modal-footer>
        <vs-button
          @click="saveEditUpdate"
          class="brdbtn"
          color="success"
          type="filled"
          >Save</vs-button
        >
        <vs-button class="brdbtn" color="dark" type="flat" @click="cancelEdit"
          >Close</vs-button
        >
      </template>
    </b-modal>

    <!-- Modal for delete -->
    <b-modal id="modal-delete" ref="modal-delete" centered>
      <template #modal-title>
        <b class="text-danger">
          <vs-icon icon="delete" size="small" color="red"></vs-icon>Delete
          User</b
        >
      </template>
      <p class="my-4">Do you want to delete user?</p>
      <template #modal-footer="{ cancel }">
        <b-button id="btncancel" variant="light" @click="cancel()">
          Cancel
        </b-button>
        <vs-button
          color="danger"
          style="border-radius: 20px"
          size="sm"
          @click="deleteWorkOrder()"
          type="filled"
          >Delete</vs-button
        >
      </template>
    </b-modal>

    <!-- Modal for ReturnParts -->
    <b-modal
      id="modal-returnpart"
      centered
      size="lg"
      :user="'partsRequest'"
      :user2="'WOreturn'"
    >
      <template #modal-title> Part return </template>
      <!-- <Pre>{{ WOreturn }}</Pre> -->
      <template>
        <vs-card style="border-radius: 20px" class="mt-4">
          <vs-row
            ><p v-for="(name, key) in partsRequest" :key="key">
              # Order - {{ name.order_id }}&nbsp;&nbsp;,&nbsp;&nbsp;
            </p></vs-row
          >
          <!-- <Pre>{{ WOreturn }}</Pre> -->
          <vs-row
            v-for="(reqitem, index) in WOreturn"
            :key="index"
            class="ml-3 mb-2"
          >
            <vs-input
              label="Part Name"
              placeholder="Placeholder"
              v-model="reqitem.part_name"
              disabled
              class="mr-2"
            />
            <div>
              <vs-input-number
                v-model="reqitem.quantity"
                label="take away :"
                :is-disabled="true"
                class="mt-4 pt-2 mr-5"
              />
              <vs-input-number
                v-model="reqitem.quantity_return"
                label="take away :"
                :is-disabled="true"
                min="0"
                :max="reqitem.quantity"
                class="mt-4 pt-2 mr-5"
              />
              <!-- <vs-input-number
                v-model="qrtreturn['order' + partreq.order_id][index2]"
                label="return :"
                min="0"
                :max="reqitem.quantity"
                class="mt-4 pt-2"
              /> -->
            </div>
          </vs-row>
        </vs-card>
        <!-- <vs-card v-for="(partreq, index) in partsRequest" :key="index">
          # Order - {{ partreq.order_id }}
          <br />
          <br />
          <vs-row
            v-for="(reqitem, index2, key) in partreq.order_items"
            :key="key"
            class="ml-3"
          >
            <vs-input
              label="Part Name"
              placeholder="Placeholder"
              v-model="reqitem.part_name"
              disabled
              class="mr-2"
            />
            <div>
              <vs-input-number
                v-model="reqitem.quantity"
                label="take away :"
                disabled
                :is-disabled="true"
                class="mt-4 pt-2 mr-5"
              />

              <vs-input-number
                v-model="qrtreturn['order' + partreq.order_id][index2]"
                label="return :"
                min="0"
                :max="reqitem.quantity"
                class="mt-4 pt-2"
              />
            </div>
          </vs-row>
        </vs-card> -->
      </template>
      <template #modal-footer>
        <vs-button color="red" style="width: 10%; border-radius: 20px" @click="closemd"
          >Close</vs-button
        >
        <vs-button @click="test(WOreturn)" style="border-radius: 20px"
          >Return Part</vs-button
        >
      </template>
    </b-modal>
  </div>
</template>

<script>
import downtime from "../Workorder/Modal/downtime.vue";
import EditWorkOrder from "../Workorder/Modal/EditWorkOrder​.vue";
import printTemplate from "../../dashboard/Workorder/btnBulkaction/printTemplate.vue";
import WorkTemplate from "../../Page/WorkTemplate.vue";
import btnBulk from "../Workorder/btnBulkaction/btnBulk.vue";
import btnMultiple from "../Workorder/btnBulkaction/btnMulti.vue";
import btnPrint from "../../../components/Page/Button/btnPrint.vue";
import modalWorkView from "../Workorder/Modal/modalWorkView.vue";
import BulkCompleteTasks from "../Workorder/BulkCompleteTasks.vue";
import FormRenderer from "v-form-builder";
import XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import moment from "moment";
import dashboardVue from "../kubota/dashboard.vue";
export default {
  props: {
    workerlist: Array,
    workerwork: Array,
    tempdata: Array,
    users: Array,
    header: Array,
    arrFilter: Array,
    saveEdit: Function,
    headerFilter: Array,
    filterPriority: Array,
    filterResponse: Array,
    filterAsset: Array,
    filterActive: Array,
    filterAssignedTo: Array,
    role: String,
  },
  components: {
    EditWorkOrder,
    isActive: true,
    printTemplate,
    hasError: false,
    BulkCompleteTasks,
    FormRenderer,
    modalWorkView,
    btnPrint,
    btnBulk,
    btnMultiple,
    WorkTemplate,
    downtime,
  },
  data: () => ({
    downtime: {
      complete: { hour: 0, minute: 0 },
      downtime: { status: false, hour: 0, minute: 0 },
    },
    colo: [],
    viewdata: "",
    dataPrint: [],
    componentKey: 0,
    selectT: true,
    viewpercentage: 0,
    arrHeader: [
      "ID",
      "Priority",
      "WO Name",
      "Asset",
      "Assigned To",
      "E-mail",
      "Creator",
      "Start Date",
      "Actual Start Date",
      "End Date",
      "Actual End Date",
      "Status",
      "Detail",
    ],
    viewwork: [],
    buttonDelete: "",
    buttonComplete: "",
    value1: "",
    value2: "",
    formData: "",
    descriptionItems: [10, 20],
    selected: [],
    selectAllWO: false,
    selected2: 0,
    formData: null,
    formInputData: null,
    showWork: false,
    attributes: [
      {
        key: "today",
        highlight: true,
        dates: new Date(),
      },
      // {
      //   dot: {
      //     color: 'red',
      //   },
      //   dates: [
      //     new Date(2020, 9, 5)
      //   ]
      // }
    ],
    selectedWO: [],
    ot: 0,
    selectFilter: [],
    options1: [{ text: "Name", value: "Name" }],
    options2: [
      { text: "Work Order", value: "Work Order" },
      { text: "Asset", value: "Asset" },
      { text: "Status", value: "Status" },
    ],
    options3: [{ text: "Clear Filter", value: "clear" }],
    lt: 0,
    odt: 0,
    ct: 0,
    ts: 0,
    og: 0,
    activePrompt: false,
    activePrompt2: false,
    checker: "List",
    newwork: {
      name: "",
      detail: "",
      iscomplete: false,
      form: { formConfig: { headline: null } },
      email: "",
      timestamp: "",
      plandate: "",
      duedate: "",
      finishtime: "",
      username: "",
    },

    selectedday: null,
    formlist: [],
    show: false,
    // workerlist: [],
    // tempdata: [],
    tablename: "List Table",
    // users: [],
    users2: [],
    // workerwork: [],
    temp: null,
    viewwork: null,
    role: "",
    stateColor: [],
    dataExport: [],
    dataBody: [],
    opened: [],
    filtervalue: [],
    filter_input: [
      {
        priority: "",
        name: "",
        id: "",
        asset: "",
        username: "",
        plandate: "",
        duedate: "",
        state: "",
      },
    ],
    primeTable: [],
    counter: 0,
    searchh: "",
    searchHeader: "",
    searchItem: "",
    searchItem2: "",
    // for filter
    selectFilterName: "",
    selectFilterPriority: "",
    selectFilterAssignedTo: "",
    selectFilterCreator: "",
    selectFilterStartDate: "",
    selectFilterEndDate: "",
    selectFilterActive: "",
    selectFilterType: "",
    selectFilterResponse: "",
    selectFilterAsset: "",

    filterCreator: [],

    dataFilterWO: [],
    tempWO: [],
    filterType: [
      { text: "Planned", value: true },
      { text: "Unplanned", value: false },
    ],
    partsRequestheader: [
      "order_id",
      "order_items",
      // "currency",
      "status",
      "timestamp",
    ],
    partsRequest: [],
    orderDeatail: {},
    total_cost: 0,
    total_part: 0,
    qrtreturn: 0,
    WOreturn: [],
  }),
  methods: {
    closemd(){
      
       this.$bvModal.hide("modal-returnpart")
    },
    test(data) {
      const data2 = this.partsRequest[0];
      var totalpartscost = 0;
      var total_retun_cost = 0;
      let orderItems = data;
      let returnItems = data;

      //Order
      orderItems.forEach((e) => {
        e.paid_price = e.quantity * e.item_price;
        totalpartscost += e.quantity * e.item_price;
      });

      //Return
      returnItems.forEach((e) => {
        e.paid_price = e.quantity_return * e.item_price;
        e.quantity = Number(e.quantity);
        total_retun_cost += e.quantity_return * e.item_price;
      });

      //Order Items
      data2.order_items = orderItems;
      data2.return_items = returnItems;

      //Total Cost
      data2.total_parts_cost = totalpartscost;
      data2.total_parts_return_cost = total_retun_cost;
      console.log(data2);
      //API Request
      this.$API
        .post(`work/${this.viewdata.id}/part/return`, data2)
        .then((res) => {
          {
            this.$vs.notify({
              title: "Submitted",
              text: "Work order has been Submitted",
              color: "success",
              position: "top-center",
            });
            setTimeout(() => {
              location.reload();
            }, 1000);
          }
        });
    },
    getpart() {
      this.$API.get(`work/${this.viewdata.id}/part/return`).then((res) => {
        this.WOreturn = res.data;
        console.log(res.data, "part/return");
      });
      this.$API.get(`work/${this.viewdata.id}/part/request`).then((res) => {
        console.log(res.data, "part/request");
        const partrequest = res.data;
        this.partsRequest = [];
        this.total_cost = 0;
        this.total_part = 0;
        partrequest.forEach((req) => {
          if (req.status == "Approved") {
            this.partsRequest.push(req);
            this.total_cost += req.total_parts_cost;
            req.order_items.forEach((item) => {
              this.total_part += item.quantity;
            });
          }
        });
        console.log(this.partsRequest);
      });
    },
    cancelEdit() {
      this.$refs["modalEdit"].hide();
    },
    Downtime(item) {
      this.$refs["modalDowntime"].show();
      // this.imagesData = item;
    },
    hideDowntime(item) {
      this.$refs["modalDowntime"].hide();
      // this.imagesData = item;
    },
    submitWO(item) {
      console.log(item);
      // this.Downtime();
      if (!item.comment) item.comment = null;
      let body = {
        comment: item.comment,
      };
      this.$API
        .put(`work/${item.id}/submit`, body)
        .then((result) => {
          this.$vs.notify({
            title: "Submitted",
            text: "Work order has been Submitted",
            color: "success",
            position: "top-center",
          });
          setTimeout(() => {
            location.reload();
          }, 1000);
        })
        .catch((err) => {
          this.$vs.notify({
            title: "Error",
            text: err.response.data.error,
            color: "danger",
            position: "top-center",
          });
          console.log(err.response.status);
          console.log(err.response.data);
        });
    },
    width200() {
      document.getElementById("myDiv").style.padding = "110px 0";
    },
    remove(item) {
      this.searchHeader.splice(this.searchHeader.indexOf(item), 1);
      switch (item) {
        case "WO Name":
          this.selectFilterName = "";
          break;
        case "Priority":
          this.selectFilterPriority = "";
          break;
        case "Assigned To":
          this.selectFilterAssignedTo = "";
          break;
        case "Creator":
          this.selectFilterCreator = "";
          break;
        case "Start Date":
          this.selectFilterStartDate = "";
          document.getElementById("myDiv").style.padding = "0";
          break;
        case "End Date":
          this.selectFilterEndDate = "";
          document.getElementById("myDiv").style.padding = "0";
          break;
        case "Status":
          this.selectFilterActive = "";
          break;
        case "Response":
          this.selectFilterResponse = "";
          break;
        case "Asset":
          this.selectFilterAsset = "";
          break;
        default:
          console.log("Try looking up for a hint.");
      }
    },
    saveEditUpdate() {
      console.log(this.updateData);
      console.log(this.$url3 + "work/" + this.updateData.id + "/edit");
      console.log(this.updateData.id);
      this.$API
        .post(this.$url3 + "work/" + this.updateData.id + "/edit", {
          data: this.updateData,
        })
        .then(() => {
          // location.reload();
        });
    },
    pushData() {
      this.dataPrint.push(this.viewdata);
    },
    // getResponse(){
    //   // console.log(this.viewdata.id);

    // this.$API.get(`work/${this.viewdata.id}/log`).then((result) => {
    //   this.getResponseST.push(result.data);
    //   // console.log("aaaaa");
    //   this.getResponseST[0].forEach((element) => {
    //     // console.log(element.response);
    //     switch (element.response) {
    //       case "created":
    //         this.resprintCreated.push(element);
    //         break;
    //       case "acknowledged":
    //         this.resprintAcknowledged.push(element);
    //         break;
    //       case "Submitted":
    //         this.resprintSubmitted.push(element);
    //         break;
    //       case "Approved":
    //         this.resprintApproved.push(element);
    //         break;
    //       case "Rejected":
    //         this.resprintRejected.push(element);
    //         break;
    //       case "Declined":
    //         this.resprintDeclined.push(element);
    //         break;
    //       case "Cancelled":
    //         this.resprintCancelled.push(element);
    //         break;
    //       default:
    //         console.log("Try looking up for a hint.");
    //     }
    //   });
    // });
    // console.log( this.resprintCreated)
    // },
    printTemplate() {
      console.log(this.dataPrint);
      this.dataPrint.push({});
      this.$session.set("dataPrint", this.dataPrint);
      this.$session.set("b", this.dataPrint);
      this.$router.push({
        name: "printTemplate",
        params: {
          dataPrint: this.dataPrint,
          b: this.dataPrint,
        },
      });
    },
    cancelReload() {
      this.$refs["modal-2"].hide();
      this.dataPrint = [];
    },
    printmodal() {
      const modal = document.getElementById("modal-2");
      const cloned = modal.cloneNode(true);
      let section = document.getElementById("print");

      if (!section) {
        section = document.createElement("div");
        section.id = "print";
        document.body.appendChild(section);
      }

      section.innerHTML = "";
      section.appendChild(cloned);
      window.print();
    },
    toggle(item) {
      console.log(item);
      const index = this.opened.indexOf(item);
      if (index > -1) {
        this.opened.splice(index, 1);
      } else {
        this.opened.push(item);
      }
      console.log(this.opened);
    },
    async completeTask() {
      console.log("hello");
      console.log(this.buttonComplete);
      const body = {
        id: this.buttonComplete.id,
        username: this.buttonComplete.username,
        status: "true",
      };
      await this.$API
        .post("updateworkstatus", body)
        .then((result) => {
          if (result.status == 200)
            this.$vs.notify({
              title: "Work Order Updated",
              text: "Your work order has been updated",
              color: "primary",
              position: "top-center",
            });
          setTimeout(() => {
            location.reload(1);
          }, 1000);
        })
        .catch((err) => {
          if (err.response.status == 500)
            this.$vs.notify({
              title: "Invalid",
              text: "Please try again",
              color: "warning",
              position: "top-center",
            });
        });
      console.log(body);
    },
    // export PDF
    exportPDF() {
      console.log(this.tempdata);
      let dataPriority = "";
      this.tempdata.forEach((element) => {
        if (element.priority == "1") {
          this.dataPriority = "1-Low Priority";
        } else if (element.priority == "2") {
          this.dataPriority = "2-Medium Priority";
        } else if (element.priority == "3") {
          this.dataPriority = "3-High Priority";
        } else {
          this.dataPriority = "-";
        }
        this.dataBody.push({
          Work_ID: element.id,
          priority: this.dataPriority,
          work_order: element.name,
          asset: element.asset,
          name: element.username,
          email: element.email,
          creator: "creator",
          start_date: element.plandate,
          actual_start_date: element.startdate,
          end_date: element.duedate,
          actual_end_date: element.finishtime,
          status: element.iscomplete,
          detail: element.detail,
        });
      });
      console.log(this.dataBody);
      var doc = new jsPDF("p", "pt");
      doc.setFontSize(8).text("Work Order", 40, 40);
      var newDat = moment().format("MM/DD/YYYY hh:mm:ss");
      doc.setFontSize(7).text(505, 25, newDat);
      var values = this.dataBody.map((elemento) => Object.values(elemento));
      console.log(values);
      doc.autoTable({
        theme: "striped",
        headStyles: {
          fillColor: [50, 192, 64],
          textColor: [255, 255, 255],
          overflow: "wrap",
        },
        styles: { fontSize: 6, theme: "plain", cellWidth: "15" },
        head: [this.arrHeader],

        body: values,
        margin: { top: 50 },
      });
      doc.save("exportWO.pdf");
      this.dataBody = [];
    },
    // export xlsx
    onExport() {
      console.log(this.tempdata);
      let dataPriority = "";
      this.tempdata.forEach((element) => {
        if (element.priority == "1") {
          this.dataPriority = "1 - Low Priority";
        } else if (element.priority == "2") {
          this.dataPriority = "2 - Medium Priority";
        } else if (element.priority == "3") {
          this.dataPriority = "3 - High Priority";
        } else {
          this.dataPriority = "-";
        }
        this.dataExport.push({
          work_id: element.id,
          priority: this.dataPriority,
          work_order: element.name,
          asset: element.asset,
          name: element.username,
          email: element.email,
          creator: "creator",
          start_date: element.plandate,
          actual_start_date: element.startdate,
          end_date: element.duedate,
          actual_end_date: element.finishtime,
          status: element.iscomplete,
          detail: element.detail,
        });
      });
      const dataWS = XLSX.utils.json_to_sheet(this.dataExport);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, dataWS);
      XLSX.writeFile(wb, "exportWO.xlsx");
      this.dataExport = [];
    },
    deleteWorkOrder() {
      console.log("hello");
      console.log(this.buttonDelete);
      const body = {
        id: this.buttonDelete.id,
        username: this.buttonDelete.username,
      };
      console.log(body);
      this.$API
        .post("deletework", body)
        .then((result) => {
          if (result.status == 200)
            this.$vs.notify({
              title: "Work Order Deleted",
              text: "Your work order has been deleted",
              color: "primary",
              position: "top-center",
            });
          setTimeout(() => {
            location.reload(1);
          }, 1000);
        })
        .catch((err) => {
          if (err.response.status == 500)
            this.$vs.notify({
              title: "Invalid",
              text: "Please try again",
              color: "warning",
              position: "top-center",
            });
        });
    },
    select() {
      this.selectAllWO = false;
    },
    selectWO() {
      this.selectedWO = [];
      if (!this.selectAllWO) {
        for (let i in this.tempdata) {
          console.log(i);
          this.selectedWO.push(this.tempdata[i]);
          const index = this.opened.indexOf(i);
          this.opened.map((i) => Number(i));
          this.opened.push(parseInt(i));
        }
        this.resultData = this.opened.map((item) => Number(item));
        console.log(this.resultData);
      } else {
        this.opened = [];
      }
    },
    showModalCom() {
      this.$refs["modal-2"].show();
    },
    showModalEdit() {
      this.$refs["modalEdit"].show();
      this.updateData = this.viewdata;
      console.log(this.updateData);
    },
    showModalDelete() {
      this.$refs["modal-delete"].show();
    },
    savedetail() {
      this.$API
        .post("work/update", {
          inputdata: this.formInputData,
          editdate: this.$moment().format("YYYY-MM-DD HH:mm:ss"),
          id: this.viewwork.id,
        })
        .then(() => {
          location.reload();
        });
      this.activePrompt = false;
    },
    refresh() {
      location.reload();
    },
    showMsgBoxOne(item) {
      this.boxOne = "";
      this.$bvModal
        .msgBoxOk("Action completed", {
          title: "Work Detail",
          size: "xl",
          buttonSize: "sm",
          okVariant: "success",
          headerClass: "p-2 border-bottom-0",
          footerClass: "p-2 border-top-0",
          centered: true,
        })
        .then((value) => {
          this.boxOne = value;
        })
        .catch((err) => {
          // An error occurred
        });
    },
    showWorkOrder(item) {
      console.log(item);
      this.viewwork = item;
      this.showWork = true;
    },
    filterchange(mode) {
      this.checker = mode;
      switch (mode) {
        case "User":
          this.tablename = "User Table";
          break;
        case "Calendar":
          this.users = [];
          this.tablename = "Work on this day";
          this.clicked(this.$moment().format("YYYY-MM-DD"), 2);
          break;
        case "List":
          this.users = this.tempdata;
          this.tablename = "List Table";
          break;
      }
    },
    clicked(item, mode) {
      console.log(item);
      this.users2 = [];
      switch (mode) {
        case 1:
          this.tablename = "Work on " + item.ariaLabel;
          this.tempdata.forEach((element) => {
            if (
              this.$moment(element.plandate).format("YYYY-MM-DD") == item.id
            ) {
              this.users2.push(element);
            }
          });
          break;
        case 2:
          this.tempdata.forEach((element) => {
            if (this.$moment(element.plandate).format("YYYY-MM-DD") == item) {
              this.users2.push(element);
            }
          });
      }
    },
    actionchange(item, mode) {
      this.newwork.timestamp = this.$moment().format("YYYY-MM-DD HH:mm:ss");
      switch (mode) {
        case 1:
          this.newwork.name = item.name;
          this.newwork.email = item.email;
          break;
        case 2:
          this.newwork.form = item.conf;
          break;
      }
    },
    newworksent() {
      this.newwork.duedate = this.$moment(this.newwork.duedate).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      this.$API.post("work/save", {
        headers: {
          "Access-Control-Request-Method": "*",
          "Access-Control-Request-Headers": "*",
          Origin: "*",
        },
        name: this.newwork.name,
        detail: this.newwork.detail,
        iscomplete: false,
        form: this.newwork.form,
        email: this.newwork.email,
        timestamp: this.newwork.timestamp,
        duedate: this.newwork.duedate,
        plandate: this.newwork.plandate,
        finishtime: this.newwork.finishtime,
        username: this.$session.get("username"),
      });
      console.log(this.newwork);
    },
    copysent(item) {
      console.log(item);
      Object.keys(item).forEach((element) => {
        if (item[element] == "-") item[element] = null;
      });
      var name = item.name + " - Copy";
      this.$API
        .post("work/save", {
          headers: {
            "Access-Control-Request-Method": "*",
            "Access-Control-Request-Headers": "*",
            Origin: "*",
          },
          name: name,
          detail: item.detail,
          iscomplete: false,
          form: item.form,
          email: item.email,
          timestamp: item.timestamp,
          duedate: item.duedate,
          plandate: item.plandate,
          finishtime: item.finishtime,
          username: this.$session.get("username"),
        })
        .then(() => {
          location.reload();
        });
    },
    handleSelected(tr) {
      this.viewwork = tr;
      console.log("hellllll");
      this.$refs["my-modalSelect"].show();
      this.$vs.notify({
        title: `Selected ${tr.username}`,
        text: `Email: ${tr.email}`,
      });
    },
  },

  computed: {
    pairs() {
      return data.map((tr, i) => {
        return {
          tr: tr,
          stateColor: stateColor[i],
        };
      });
    },
    filteredList() {
      return this.tempdata.filter((post) => {
        return (
          post.name
            .toString()
            .toLowerCase()
            .includes(this.selectFilterName.toLowerCase()) &&
          post.priority
            .toString()
            .toLowerCase()
            .includes(this.selectFilterPriority) &&
          post.response
            .toString()
            .toLowerCase()
            .includes(this.selectFilterResponse.toLowerCase()) &&
          post.iscomplete
            .toString()
            .toLowerCase()
            .includes(this.selectFilterActive.toLowerCase()) &&
          post.username
            .toString()
            .toLowerCase()
            .includes(this.selectFilterAssignedTo.toLowerCase()) &&
          post.plandate
            .toString()
            .toLowerCase()
            .includes(this.selectFilterStartDate) &&
          // post.asset
          //   .toString()
          //   .toLowerCase()
          //   .includes(this.selectFilterAsset.toLowerCase()) &&
          post.duedate
            .toString()
            .toLowerCase()
            .includes(this.selectFilterEndDate)
        );
      });
    },
  },
};
</script>

<style>
#__BVID__8124 {
  padding-left: 0;
}
#viewData:hover {
  text-decoration: underline;
}
#viewData {
  color: greesn;
}
#viewAsset {
  color: #32c040;
}
#viewAsset:hover {
  transform: translate(0, 4px);
  text-decoration: underline;
}
.vs-dialog {
  max-height: 90%;
  overflow-y: auto;
  overflow-x: hidden;
}
input {
  border-radius: 0px;
}
button {
  border-radius: 0px;
}
.btn.btn-primary {
  border-radius: 0px;
}
.btn.btn-secondary {
  border-radius: 0px;
}
.btn.btn-warning {
  border-radius: 0px;
}
.btn.btn-danger {
  border-radius: 0px;
}
#center {
  display: flex;
  align-items: center;
}
.btn.btn-info {
  border-radius: 0px;
}
.list-group-item.list-group-item-action {
  border-radius: 0px;
}
.form-control {
  border-radius: 0px;
}
p.copyright-text {
  display: none;
}
.selectExample {
  margin: 10px;
}
.con-select-example {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}
.con-select .vs-select {
  width: 100%;
}
.vuesax-app-is-ltr .vs-input--input.hasIcon {
  padding-left: 32px;
  border-radius: 20px;
}
.vs-select--item.con-icon.activex {
  padding-left: 30px;
}
@media (max-width: 550px) {
  .con-select {
    flex-direction: column;
  }
  .con-select .vs-select {
    width: 100%;
  }
}
th {
  padding: 0px;
}
.col-md-1.control-view-wrapper {
  padding-left: 1%;
}
.col-md-2.control-view-wrapper {
  padding-left: 1%;
}
.col-md-3.control-view-wrapper {
  padding-left: 1%;
}
.col-md-4.control-view-wrapper {
  padding-left: 1%;
}
.col-md-6.control-view-wrapper {
  padding-left: 1%;
}
.col-md-12.control-view-wrapper {
  padding-left: 1%;
}
.vs-divider-border.before.vs-divider-border-default {
  background-color: #6eda78;
}
</style>

<style scoped>
.brdbtn {
  width: 80px;
  border-radius: 20px;
}
#btnShare {
  color: #111111;
  border-radius: 20px;
  display: inline-block;
  -webkit-transition: all 0.25s ease;
  transition: all 0.25s ease;
}
#noWrap {
  padding: 0px;
  /*font-size 12px */
  font-size: 0.75rem;
  white-space: nowrap;
}
#fontSizeData {
  /*font-size 12px */
  font-size: 0.75rem;
}
#colorTextComplete {
  color: #32c040;
}
.opened {
  background-color: #e8f5e7;
  color: #32c040;
}
.openeData {
  background-color: #e8f5e7;
  color: #32c040;
}
.text-red {
  color: red;
}
input.vdatetime-input {
  border: none;
  padding-left: 10%;
  border-bottom: 1px solid black;
}
#btncancel {
  background-color: #ffffff;
  border-radius: 0;
  border-color: #ffffff;
}
.con-vs-card >>> .vs-card--header >>> .Test {
  padding-bottom: 0%;
}

.con-vs-card >>> .vs-card--header {
  background: linear-gradient(45deg, #6eda78, #2ed8b6);
  color: whitesmoke;
  border-radius: 15px 15px 1px 1px;
  padding: 5px;
}
.con-vs-card.a >>> .vs-card--header {
  background: linear-gradient(45deg, rgb(38, 192, 183), rgb(52, 211, 167));
  color: whitesmoke;
  border-radius: 15px 15px 1px 1px;
  padding: 5px;
}
.con-vs-card.b >>> .vs-card--header {
  background: linear-gradient(45deg, rgb(238, 122, 111), rgb(248, 178, 143));
  color: whitesmoke;
  border-radius: 15px 15px 1px 1px;
  padding: 5px;
}
.con-vs-card.c >>> .vs-card--header {
  background: linear-gradient(45deg, rgb(86, 135, 232), rgb(55, 185, 224));
  color: whitesmoke;
  border-radius: 15px 15px 1px 1px;
  padding: 5px;
}
.con-vs-card.d >>> .vs-card--header {
  background: linear-gradient(45deg, rgb(243, 126, 151), rgb(243, 126, 151));
  color: whitesmoke;
  border-radius: 15px 15px 1px 1px;
  padding: 5px;
}
.selectExample {
  margin: 10px;
}
.con-select-example {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}
.con-select .vs-select {
  width: 100%;
}
@media (max-width: 550px) {
  .con-select {
    flex-direction: column;
  }
  .con-select .vs-select {
    width: 100%;
  }
}
.vschip {
  font-size: 100%;
}
th {
  padding: 0px;
}
.con-vs-dialog >>> .vs-dialog {
  width: 50%;
  max-width: 1000px;
}

button#dropdown-1_BV_toggle_.btn.dropdown-toggle.btn-secondary {
  border-radius: 5px;
}
</style>
<style >
th .sort-th .th-sort-icon {
  color: white;
  padding: 0px;
}
</style>